import Gator from "gator";
import jump from "jump.js";

_gg.Gator = Gator;
_gg.jump = jump;
